<template>
  <div class="dialog-wrap">
    <el-dialog title="新建课程章节"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="handleOpen"
               width="680px">
      <el-form :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="120px"
               class="demo-dataForm">
        <el-form-item label="章节名称："
                      prop="name">
          <div style="display:flex"> <el-input v-model="dataForm.name"
                      placeholder="输入章节名称"
                      style="width:90%;marginRight:10px"
                      maxlength="50"
                      @input="nameInput"></el-input><span>{{number}}/50</span></div>
        </el-form-item>
        <el-form-item label="发布状态："
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
        <el-form-item label="试看状态："
                      prop="trial"
                      v-if="dataForm.extra_type==1 || dataForm.extra_type==2||dataForm.extra_type==3">
          <el-switch v-model="dataForm.trial"></el-switch>
        </el-form-item>
        <!--    <el-form-item label="CC视频ID：">
          <div class="input-box">
            <el-input v-model="dataForm.ccid" placeholder="输入CC视频ID"></el-input>
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="false"
              :on-change="handleToFileUpload"
              accept='.wmv,.wm,.asf,.asx,.rm,.rmvb,.ra,.ram,.mpg,.mpeg,.mpe,.vob,.dat,.mov,.3gp,.mp4,.mp4v,.m4v,.mkv,.avi,.flv,.f4v,.mts,.wav,.aif,.aiff,.au,.snd,.voc,.mp3,.ra,.mid,.rmi,.wma,.ape,.flac,.aac,.m4a,.vqf'
              :auto-upload="false">
              <el-button size="small" type="primary">上传视频文件</el-button>
            </el-upload>
          </div>
        </el-form-item> -->
        <!--    <el-form-item
          label="短书链接："
          prop="name"
        >
          <el-input
            v-model="dataForm.chapter_link_url"
            placeholder="输入链接"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="课时类型："
                      prop="extra_type">
          <el-radio-group v-model="dataForm.extra_type">
            <el-radio :label="2">新建直播</el-radio>
            <el-radio :label="1">录播</el-radio>
            <el-radio :label="0">测试卷</el-radio>
            <el-radio :label="3">关联已有直播</el-radio>
            <el-radio :label="4">阿里云录播</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label=""
                      v-if="dataForm.extra_type==3">
          <el-input v-model="dataForm.baijia_room_id"
                    placeholder="输入房间ID"
                    oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label=""
                      v-if="dataForm.extra_type==1">
          <el-input v-model="dataForm.baijia_video_id"
                    placeholder="输入资源ID"
                    oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="教室容量："
                      prop="max_users"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex">
            <el-input v-model="dataForm.max_users"
                      placeholder="人数上限"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      style="width:30%;marginRight:10px"></el-input>
            <el-checkbox v-model="maxUserCheck"
                         @change="handleCheck"
                         size="30px">不设上限</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="课程时长："
                      prop="duration_time"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex">
            <el-time-select v-model="dataForm.duration_time"
                            style="width:30%;marginRight:10px"
                            @change="timeChange"
                            :picker-options="{
                           start: '00:30',
                           step: '00:30',
                            end: '24:00'
  }"
                            placeholder="选择时间">
            </el-time-select>
            <el-checkbox v-model="islongeRoom"
                         size="30px">长期房间</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="开始时间："
                      prop="start_time"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex">
            <el-date-picker v-model="dataForm.start_time"
                            @change="handleDateChange"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm"
                            value-format="timestamp"
                            placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="有无学生上麦："
                      prop="has_student_raise"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex;marginTop:10px">
            <el-radio-group v-model="dataForm.has_student_raise">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">有</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="主讲老师："
                      prop="master_teacher_obj"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex; flex-flow: wrap;">
            <el-tag v-for="tag in dataForm.master_teacher_obj"
                    :key="tag.name"
                    @close="tagClose(tag,1)"
                    style="marginRight:5px"
                    closable>
              {{tag.name}}/{{tag.phone_number}}
            </el-tag>
            <span style="color:#409EFF;cursor: pointer;"
                  @click="choseTeacher">选择老师</span>
          </div>
        </el-form-item>
        <el-form-item label="助教老师："
                      prop="assistant_teacher_list"
                      v-if="dataForm.extra_type==2">
          <div style="display:flex; flex-flow: wrap;">
            <el-tag v-for="tag in dataForm.assistant_teacher_list"
                    :key="tag.name"
                    @close="tagClose(tag,2)"
                    style="marginRight:5px"
                    closable>
              {{tag.name}}/{{tag.phone_number}}
            </el-tag>
            <span style="color:#409EFF;cursor: pointer;"
                  @click="choseAssistantTeacher">选择老师</span>
          </div>
        </el-form-item>
        <div class="btBox"
             v-if="dataForm.extra_type==4">
          <input @change="upload"
                 type="file"
                 name="photoImg"
                 id="getFile"
                 style="display:none;"
                 class="upload-input" />
          <label for="getFile"
                 class="fileStyle">上传视频</label>
        </div>
        <div class="prism-player"
             id="J_prismPlayer"
             style="marginTop:15px;marginLeft:30px"
             v-if="dataForm.extra_type==4&&this.vod_video_id !=null"></div>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <Teacher :visible="teacherDiag"
             :type="type"
             @close="teacherClose()"
             @submit="chooseSubmit"
             @submits="chooseAssignSubmit"></Teacher>
  </div>
</template>

<script>
import bus from '@/components/common/bus'
import { courseChapterUpdate, measureScroll, courseTest } from '@/api/course'
import { videoInfoCreate, uploadVideo } from '@/api/common'
import Teacher from '@/components/dialog/course/CourseTeacher'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    product_id: {
      type: String,
      default: '',
    },
  },
  components: {
    Teacher,
  },
  data() {
    return {
      vod_video_id: null,
      number: 0,
      dialogVisible: this.visible,
      teacherDiag: false,
      maxUserCheck: false,
      islongeRoom: false,
      chooseTeacher: [],
      value1: '',
      milliseconds: null,
      type: null,
      // start_time: '',
      dataForm: {
        extra_type: 1,
        has_student_raise: 0,
        master_teacher_obj: [],
        assistant_teacher_list: [],
      },
      filelist: [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
        { name: 6 },
        { name: 7 },
      ],
      rules: {
        name: [{ required: true, message: '请输入章节名称', trigger: 'blur' }],
        baijia_video_id: [
          { required: true, message: '请输入资源ID', trigger: 'change' },
        ],
        baijia_room_id: [
          { required: true, message: '请输入房间ID', trigger: 'change' },
        ],
        extra_type: [
          { required: true, message: '请选择课时类型', trigger: 'change' },
        ],
        max_users: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value & !this.maxUserCheck) {
                callback(new Error('输入人数上限'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
          // { required: true, message: '输入人数上限', trigger: 'blur' },
        ],
        start_time: [
          { required: true, message: '请输入上课时间', trigger: 'change' },
        ],
        has_student_raise: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        master_teacher_obj: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请选择至少一个主讲老师'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        assistant_teacher_list: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请选择至少一个助教老师'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        duration_time: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请选择课程时长'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      // this.dataForm = Object.assign({}, val)
      // this.dataForm.status = this.dataForm.status == 1 ? true : false
      // this.dataForm.trial = this.dataForm.trial == 1 ? true : false
      console.log('创建', val)
    },
  },
  // beforeDestroy() {
  //   if (this.player) {
  //     this.player.dispose()
  //     this.player = null
  //   }
  // },
  methods: {
    upload(e) {
      const file = e.target.files[0]
      if (file) {
        /******  此处为上传服务器 start   ******/
        let content = new FormData()
        content.append('file', file)
        uploadVideo(content).then((res) => {
          this.vod_video_id = res.vod_video_id
          this.$nextTick(() => {
            this.initPlayer(res.vod_temp_preview_url)
          })
        })
      }
    },
    // 在你的 Vue 组件的 methods 中
    initPlayer(url) {
      if (window.Aliplayer) {
        console.log('333')
        this.createPlayer(url)
        return
      }
      console.log('444')
      // 动态创建 link 标签加载 CSS
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href =
        'https://g.alicdn.com/apsara-media-box/imp-web-player/2.33.0/skins/default/aliplayer-min.css'
      document.head.appendChild(link)

      // 动态创建 script 标签加载 JS
      const script = document.createElement('script')
      script.src =
        'https://g.alicdn.com/apsara-media-box/imp-web-player/2.33.0/aliplayer-min.js'
      script.onload = () => {
        console.log('Aliplayer SDK 加载完成')
        this.createPlayer(url)
      }
      script.onerror = () => {
        console.error('Aliplayer SDK 加载失败')
      }
      document.head.appendChild(script)
    },
    createPlayer(url) {
      if (this.player) {
        this.$nextTick(() => {
          console.log('this.player', this.player)
          this.player.loadByUrl(url, 'mp4')
        })
      } else {
        this.player = new window.Aliplayer( // 这里最好使用 window.Aliplayer
          {
            license: {
              domain: 'kaoyanbox.net',
              key: 'dPxsbwpNjoXVqVFgt62685f680df745619ca01bc0101c4075',
            },
            id: 'J_prismPlayer',
            width: '70%', // 可以是百分比
            height: '300px',
            source: url,
          },
          function (player) {
            console.log('播放器创建成功:', player)
          }
        )
      }
    },
    timeChange(val) {
      const [hours, minutes] = val.split(':')
      this.milliseconds = hours * 3600000 + minutes * 60000
    },
    choseTeacher() {
      this.type = 1
      this.teacherDiag = true
    },
    handleCheck(val) {
      if (val) {
        this.$refs.dataForm.clearValidate('max_users')
      }
    },
    choseAssistantTeacher() {
      this.type = 2
      this.teacherDiag = true
    },
    chooseSubmit(val) {
      this.dataForm.master_teacher_obj = val
      const commonObjects = val.filter((obj1) =>
        this.dataForm.assistant_teacher_list.some(
          (obj2) => obj1.name === obj2.name
        )
      )
      if (commonObjects.length > 0) {
        this.$message.error(`主讲老师和助教老师不能重复`)
      }
      // 需要id-直接后面链式map
      this.$refs.dataForm.clearValidate('master_teacher_obj')
    },
    chooseAssignSubmit(val) {
      val.map((item) => {
        this.dataForm.assistant_teacher_list.push(item)
      })
      // this.dataForm.assistant_teacher_list = val
      const commonObjects = val.filter((obj1) =>
        this.dataForm.master_teacher_obj.some((obj2) => obj1.name === obj2.name)
      )
      if (commonObjects.length > 0) {
        this.$message.error(`主讲老师和助教老师不能重复`)
      }
      this.$refs.dataForm.clearValidate('assistant_teacher_list')
    },
    tagClose(val, t) {
      if (t == 1) {
        this.dataForm.master_teacher_obj =
          this.dataForm.master_teacher_obj.filter((v) => {
            return v.name != val.name
          })
        if (this.dataForm.master_teacher_obj.length > 0) {
          this.$refs.dataForm.clearValidate('master_teacher_obj')
        }
      } else {
        this.dataForm.assistant_teacher_list =
          this.dataForm.assistant_teacher_list.filter((v) => {
            return v.name != val.name
          })
        if (this.dataForm.assistant_teacher_list.length > 0) {
          this.$refs.dataForm.clearValidate('assistant_teacher_list')
        }
      }
    },
    teacherClose() {
      this.teacherDiag = false
    },
    nameInput() {
      this.number = this.dataForm.name.length
    },
    handleDateChange() {
      this.$refs.dataForm.validateField('start_time')
    },
    // 文件上传
    handleToFileUpload(file) {
      let params = {
        title: this.dataForm.name,
        filename: file.name,
        filesize: file.size,
      }
      videoInfoCreate(params)
        .then((res) => {
          if (res && !res.error) {
            file.ccInfo = res.uploadinfo
            bus.$emit('file-upload', file)
            this.dataForm.ccid = res.uploadinfo.videoid
          } else {
            this.$message.error(`文件上传异常`)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 创建直播点击确定
    courseDate(params) {
      courseChapterUpdate(params)
        .then((res) => {
          this.$message.success(`更新成功`)

          this.$emit('submit')
          this.handleClose()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // 创建测试卷章节
    courseTests(params) {
      courseTest(params)
        .then((res) => {
          if (this.dataForm.extra_type == 0) {
            measureScroll({
              product_type: 1,
              course_chapter_id: res.id,
              name: this.dataForm.name,
            }).then((res) => {
              this.$message.success(`创建成功`)
              // this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.$emit('addNode', res)
              this.handleClose()
            })
          } else {
            this.$message.success(`创建成功`)
            // this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.$emit('addNode', res)
            this.handleClose()
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    handleOpen() {},
    // 更新题库在线状态
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.extra_type == 2) {
            const commonObjects = this.dataForm.master_teacher_obj.filter(
              (obj1) =>
                this.dataForm.assistant_teacher_list.some(
                  (obj2) => obj1.name === obj2.name
                )
            )
            if (commonObjects.length > 0) {
              this.$message.error(`主讲老师和助教老师不能重复`)
              return
            }

            let params = {
              sort: this.content.children.length + 1,
              product_id: this.product_id,
              pid: this.content.id,
              name: this.dataForm.name,
              level: this.content.level + 1,
              status: this.dataForm.status ? 1 : 0,
              extra_type:
                this.dataForm.extra_type == 3 ? 2 : this.dataForm.extra_type,
              trial: this.dataForm.trial ? 1 : 0,
              baijia_live_room_obj: {
                title: this.dataForm.name,
                max_users: this.maxUserCheck ? 0 : this.dataForm.max_users,
                start_time: this.dataForm.start_time,
                is_long_term: this.islongeRoom ? 1 : 0,
                has_student_raise: this.dataForm.has_student_raise,
                duration_time: this.milliseconds,
                master_teacher_obj: this.dataForm.master_teacher_obj[0],
                assistant_teacher_list: this.dataForm.assistant_teacher_list,
              },
              // baijia_video_id:
              //   this.dataForm.extra_type == 1
              //     ? this.dataForm.baijia_video_id
              //     : null,
              // baijia_room_id:
              //   this.dataForm.extra_type == 2
              //     ? this.dataForm.baijia_room_id
              //     : null,
            }
            console.log('parmas', params)
            this.courseTests(params)
          } else {
            let params = {
              sort: this.content.children.length + 1,
              product_id: this.product_id,
              pid: this.content.id,
              name: this.dataForm.name,
              level: this.content.level + 1,
              status: this.dataForm.status ? 1 : 0,
              extra_type:
                this.dataForm.extra_type == 3 ? 2 : this.dataForm.extra_type,
              trial: this.dataForm.trial ? 1 : 0,
              baijia_video_id:
                this.dataForm.extra_type == 1
                  ? this.dataForm.baijia_video_id
                  : null,
              baijia_room_id:
                this.dataForm.extra_type == 3
                  ? this.dataForm.baijia_room_id
                  : null,
              vod_video_id:
                this.dataForm.extra_type == 4 ? this.vod_video_id : null,
            }
            this.courseTests(params)
          }
        }
      })
    },
    handleClose() {
      this.dataForm = {
        name: '',
        extra_type: 1,
        has_student_raise: 0,
        max_users: '',
        master_teacher_obj: [],
        assistant_teacher_list: [],
      }
      this.maxUserCheck = false
      this.islongeRoom = false
      //  maxUserCheck: false,
      // islongeRoom=false,
      this.$emit('close')
      this.$refs.dataForm.resetFields()
      this.vod_video_id = null
      // 2. 【关键】检查并销毁播放器实例
      if (this.player) {
        console.log('在 handleClose 中销毁播放器实例...')
        this.player.dispose() // 调用SDK的销毁方法
        this.player = null // 将实例引用设为null，以便下次重新创建
      }
      // if (this.player) {
      //   this.player.dispose()
      // }
    },
    handleRemove(file) {},
    handleDownload(file) {},
    handleSelectedClose() {},
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5 !important;
}
.btBox {
  margin-left: 10%;
  .fileStyle {
    position: relative;
    right: 10px;
    margin-right: 5px;
    border-radius: 1px;
    padding: 6px 15px;
    color: #409eff;
    background: #ecf5ff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #accff3;
  }
}

.dialog-wrap {
  .input-box {
    display: flex;

    .el-input {
      margin-right: 10px;
    }
  }
}
</style>
